import data from "../../../configs/data";
import {Button} from "../../../controlElements/Button";
import {ObservableContainer} from "../../../controlElements/ObservableContainer";
import {DeviceDetector} from "../../../DeviceDetector";
import {EuropeanRoulette} from "../../../EuropeanRoulette";

export class CornerBetsPanel extends ObservableContainer {

    public static readonly POSSIBLE_CORNER_BETS: Array<Array<number>> = [
        [0, 1, 2],
        [0, 2, 3],
        [1, 2, 4, 5],
        [2, 5, 3, 6],
        [4, 5, 7, 8],
        [5, 6, 8, 9],
        [7, 8, 10, 11],
        [8, 9, 11, 12],
        [10, 11, 13, 14],
        [11, 12, 14, 15],
        [13, 14, 16, 17],
        [14, 15, 17, 18],
        [16, 17, 19, 20],
        [17, 18, 20, 21],
        [19, 20, 22, 23],
        [20, 21, 23, 24],
        [22, 23, 25, 26],
        [23, 24, 26, 27],
        [25, 26, 28, 29],
        [26, 27, 29, 30],
        [28, 29, 31, 32],
        [29, 30, 32, 33],
        [31, 32, 34, 35],
        [32, 33, 35, 36],
    ];

    private buttons: Array<Button> = [];

    constructor(straightBetsButtonsOffsetX: number,
                straightBetsButtonsOffsetY: number,
                straightBetsOffsetFromZero: number) {
        super();
        this.createAndAddBetsButtons(
            straightBetsButtonsOffsetX,
            straightBetsButtonsOffsetY,
            straightBetsOffsetFromZero);
    }

    public getButtonPosition(number: number): PIXI.Point {
        return (this.buttons[number].position as PIXI.Point);
    }

    private createAndAddBetsButtons(straightBetsButtonsOffsetX: number, straightBetsButtonsOffsetY: number,
                                    straightBetsOffsetFromZero: number): void {
        let columnCurrentIndex = 0;
        for (let index = 0;
             index < EuropeanRoulette.ROULETTE_MAXIMUM_NUMBER * 2 / 3; index++) {
            const row = 1 - (index % 2);
            const button = new Button(data.images.regularNumberBaseState, data.images.regularNumberBaseState,
                data.images.regularNumberBaseState, data.images.regularNumberHoverDisableState);

            this.initializeBetButtonBehavior(button, index);
            button.position.x = straightBetsOffsetFromZero - straightBetsButtonsOffsetX / 2 +
                columnCurrentIndex * straightBetsButtonsOffsetX;
            button.position.y = row * straightBetsButtonsOffsetY + straightBetsButtonsOffsetY / 2;
            this.buttons.push(button);
            this.addChild(button);
            if (row === 0) {
                columnCurrentIndex++;
            }
        }
    }

    private onValueChosen(index: number): void {
        this.callOnClickedSubscribers(index, CornerBetsPanel.POSSIBLE_CORNER_BETS[index]);
    }

    private onHover(index: number): void {
        this.callOnPointerDownSubscribers(index, CornerBetsPanel.POSSIBLE_CORNER_BETS[index]);
    }

    private onHoverOutside(index: number): void {
        this.callOnPointerUpSubscribers(index, CornerBetsPanel.POSSIBLE_CORNER_BETS[index]);
    }

    private initializeBetButtonBehavior(button: Button, thisArg: any): void {
        button.subscribeOnClicked(this.onValueChosen.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_DOWN, this.onHover.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_CANCEL, this.onHoverOutside.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_OVER, this.onHover.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_OUT, this.onHoverOutside.bind(this, thisArg));
        if (DeviceDetector.isMobileOrTabletDevice()) {
            button.on(Button.BUTTON_EVENTS.POINTER_UP, this.onHoverOutside.bind(this, thisArg));
            button.on(Button.BUTTON_EVENTS.POINTER_UP_OUTSIDE, this.onHoverOutside.bind(this, thisArg));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/rouletteBetsPanel/implementations/CornerBetsPanel.ts